export default __webpack_public_path__ + "static/media/2.ccd966b1.svg";